<template>
    <div>
        <transition name="fade" mode="out-in" v-if="permisos['abonos.vender']">
            <div key="1" v-if="paso == 1" id="paso-1">
                <PasoUnoComponent v-on:goTo="finalizarPasoUno" :precios="precios" @setZonas="setZonas"></PasoUnoComponent>
            </div>
            <div key="2" v-if="paso == 2" id="paso-2">
                <b-row>
                    <b-col cols="12" class="text-right mb-3">
                        <Button
                            @click="goTo(1)"
                        >
                            Cambiar zona
                        </Button>
                    </b-col>
                </b-row>
            
                <PasoDosComponent
                    :key="reload"
                    :abono_seleccionado="abono_seleccionado"
                    :datos_compradores="datos_compradores"
                    :zona="zona_seleccionada"
                    :zonas="zonas"
                    v-on:goTo="finalizarPasoDos"
                    v-on:resetDatos="resetDatos"
                ></PasoDosComponent>
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="3" v-if="paso >= 3" id="paso-3">
                <PasoTresComponent 
                    :datos_compradores="datos_compradores" 
                    v-on:goTo="finalizarPasoTres" 
                    :precios="precios" 
                    :zona="zona_seleccionada" 
                    :disabled="paso >= 4"
                    @actualizar="datos => datos_compradores = datos"
                    @volver="borrarSesion" 
                    @solicitarPlazos="aplicarPlazos"
                />
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="4" v-if="paso >= 4" id="paso-4">
                <PasoCuatroComponent
                    ref="pasoCuatro"
                    :datos_compradores="datos_compradores"
                    :datos_compra="datos_compra"
                    @reiniciar="reiniciar"
                    @procesar="procesarCompra"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import PasoUnoComponent from '@/components/backend/stepper/abonos/con-recinto/PasoUnoComponent';
import PasoDosComponent from '@/components/backend/stepper/abonos/con-recinto/PasoDosComponent';
import PasoTresComponent from '@/components/backend/stepper/abonos/con-recinto/PasoTresComponent';
import PasoCuatroComponent from '@/components/backend/stepper/abonos/common/PasoCuatroComponent';

export default {
    data() {
        return {
            paso: 1,
            zona_seleccionada: null,
            zonas: null,
            datos_compradores: [],
            precios: null,
            datos_compra: null,
            abono_seleccionado: null,
            reload: 1
        }
    },
    methods: {
        finalizarPasoUno(paso, zona, abonado) {
            if(zona) {
                this.zona_seleccionada = zona;

                if(abonado) {
                    this.$router.push({name: 'back.abonos.index', query: {zona: zona.id, n_abonado_antiguo: abonado.n_abonado_antiguo}});
                }
            }
            this.paso = paso;

            this.$nextTick(function() {
                this.scrollTo('#paso-' + paso);
            });
        },
        finalizarPasoDos(paso, datos) {
            if(datos) {
                this.datos_compradores = Object.assign({}, datos);
            }
            this.paso = paso;

            this.$nextTick(function() {
                this.scrollTo('#paso-' + paso);
            });
        },
        finalizarPasoTres(paso, datos_compra) {
            this.datos_compra = datos_compra;
            this.paso = paso;

            this.$nextTick(function() {
                this.scrollTo('#paso-' + paso);
            });
        },
        getPrecios() {
            const params = {
                filters : {},
                lista_id: this.lista_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                this.precios = res.data;

                for (var i in this.precios) {
                    this.precios[i].unidades = 0;
                }
            });
        },
        procesarCompra(referido_id) {
            if (this.compraConPlazos) {
                Object.values(this.datos_compradores).forEach(comprador => {
                    delete comprador.metodo_pago;
                });
            }

            const params = {
                zona_id: this.datos_compradores[0].area.id,
                numero_entradas: this.datos_compradores.length,
                metodo_pago: this.datos_compra.metodo_pago,
                datos_compradores: this.datos_compradores
            };

            if (referido_id) {
                params.referido_id = referido_id;
            }

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.alta'), params).then(res => {
                this.$refs.pasoCuatro.compra_finalizada = true;
                this.$refs.pasoCuatro.urls_imprimir = res.data.urls_imprimir;
                this.$refs.pasoCuatro.url_factura = res.data.url_factura;
                this.$refs.pasoCuatro.error = null;
            }).catch(error => {
                this.$refs.pasoCuatro.error = error.response.data.message;
            })
        },
        reiniciar() {
            this.paso = 1;
            this.zona_seleccionada = null;
            this.datos_compradores = [];
            this.datos_compra = null;
            this.borrarSesion();
        },
        scrollTo(paso) {
            this.$scrollTo(paso, 100)
        },
        goTo(paso) {
            if(paso < this.paso) {
                if(paso == 1) {
                    this.datos_compradores = [];
                    this.paso = paso;
                }
            }
        },
        resetDatos(new_zona) {
            this.reload += 1;
            this.datos_compradores = [];
            this.zona_seleccionada = new_zona;
        },
        setZonas(zonas) {
            this.zonas = zonas;
        },
        aplicarPlazos(datos) {
            this.datos_compradores = datos;
        },
        borrarSesion() {
            this.$emit('borrarSesion', true);
        }
    },
    computed: {
        permisos() {
            return this.$store.getters.getPermisos;
        },
        lista_id() {
            return this.$store.getters.getListaId;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
        compraConPlazos() {
            const datos = Object.values(this.datos_compradores);
            return this.teatro.permitir_plazos_abonados && datos.every(abono => abono.area && abono.area.activar_pago_plazos);
        }
    },
    created() {
        this.getPrecios();
    },
    components: {
        PasoUnoComponent, PasoDosComponent, PasoTresComponent, PasoCuatroComponent
    }
}
</script>